import template from './kform-tab-rights.html';

export default {
	template,
	bindings: {
		form: '<',
		kid:  '<',
	},
	require: {
		kform: '^^kform',
	},
};
